/**
 * FidoBalance — Platform brand (owned by the SaaS publisher, NOT by tenants).
 *
 * This is the brand of the application itself, visible everywhere:
 * login, register, onboarding, app header, footer, browser title.
 *
 * Tenants (companies) have their OWN co-branding (logo + accent color)
 * that appears ALONGSIDE this brand, never replacing it — except for
 * an Enterprise plan (future) that allows full white-label via the
 * `brand_name` field on the company object.
 *
 * To rebrand the platform (e.g. renaming "FidoBalance" → "MyControl"):
 *   1. Edit `name` below.
 *   2. Replace /app/frontend/public/brand-logo.svg with your logo file
 *      (or change the `logo` path to point to your new file).
 *   3. Save — hot reload takes care of the rest.
 */
export const BRAND = {
    name: "PvrPilot",
    //tagline: "Account Companion",
    logo: "/brand-logo.svg",
    glyph: "/brand-glyph.svg",
    // Whether tenants (companies) on the current plan are allowed to
    // override the platform brand name (Enterprise white-label).
    // Currently disabled for ALL tenants — flip per-company via plan gating
    // when Stripe plans go live.
    allowTenantWhiteLabel: false,
};
